import styled from "styled-components";

export const UpdateUserModalSectionTitle = styled.div(() => ({
  fontSize: 14,
  fontWeight: "bold",
}));
